import { Subscription } from "../types/subscription";

export const transformSubscriptionsForUI = (subscriptions: Subscription[]) => {
    if (!subscriptions || !Array.isArray(subscriptions)) {
        return [];
      }
    
      return subscriptions.map(subscription => {
        let parsedDescription: any = {};
        try {
          parsedDescription = typeof subscription.description === 'string' 
            ? JSON.parse(subscription.description) 
            : subscription.description;
        } catch (error) {
          console.error(`Error parsing description for ${subscription.name}:`, error);
        }
    
        const features = parsedDescription.features as string[] || [];
    
        let savings = '';
        if (parsedDescription.savePercent && parsedDescription.savingsNote) {
          savings = `Save ${parsedDescription.savePercent}% ${parsedDescription.savingsNote}`;
        }
    
        return {
          id: subscription.id,
          title: parsedDescription.title || subscription.name,
          price: subscription.price?.unit_amount,
          priceId: subscription.price.id,
          moments: parsedDescription.moments || 0,
          features: features,
          savings: savings,
          isPopular: parsedDescription.popular === true,
        }
      });
}